export { default as TableCellData } from './TableCellData'
export type { TableCellProps } from './TableCellData.types'
